import WifiAmenityModal from "../../../Components/User/Dashboard/WifiAmenityModal/WifiAmenityModal";
import SelectCard from "../../../Components/User/Bookings/SelectCard/SelectCard";
import { retrySubscriptionPayment } from "../../../Redux/Members/MembersActions";
import { getDashboardData } from "../../../Redux/Dashboard/DashboardActions";
import { openDoor } from "../../../Redux/Bookings/BookingsActions";
import { getProfile } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import Modal from "../../../Components/Common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import WifiImage from "../../../Assets/Wifi.gif";
import LockImage from "../../../Assets/Lock.gif";
import styles from "./Dashboard.module.scss";
import { RiAlertLine } from "react-icons/ri";
import { FaUnlockAlt } from "react-icons/fa";
import { CiClock1 } from "react-icons/ci";
import { Link } from "react-router";
import moment from "moment";

function Dashboard() {
  const dispatch = useDispatch<AppDispatch>();
  const [openDoorAmenityId, setOpenDoorAmenityId] = useState<number | null>(
    null,
  );
  const [isWifiModalActive, setIsWifiModalActive] = useState(false);
  const [isSelectCardModalActive, setIsSelectCardModalActive] = useState(false);
  const [selectedCard, setSelectedCard] = useState<string>("");
  const { data, loading } = useSelector((state: RootState) => state.dashboard);
  const { openDoorData, openDoorLoading } = useSelector(
    (state: RootState) => state.bookings,
  );
  const { retrySubscriptionPaymentLoading } = useSelector(
    (state: RootState) => state.members,
  );

  useEffect(() => {
    dispatch(getDashboardData());
    dispatch(getProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDoorHandler = (amenityId: number) => {
    if (amenityId) {
      if (!openDoorLoading && !openDoorData) {
        setOpenDoorAmenityId(amenityId);
        dispatch(
          openDoor({
            amenityId: amenityId.toString(),
          }),
        );
      }
    } else {
      toastHelper.error("Amenity ID is required");
    }
  };

  const retrySubscriptionPaymentHandler = () => {
    if (selectedCard) {
      if (!retrySubscriptionPaymentLoading) {
        dispatch(
          retrySubscriptionPayment({
            cardId: selectedCard,
          }),
        );
      }
    } else {
      toastHelper.error("Please select a card");
    }
  };

  const wifiHandler = () => {
    setIsWifiModalActive(true);
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <React.Fragment>
      {retrySubscriptionPaymentLoading && <Loading />}
      <Modal
        isOpen={isSelectCardModalActive}
        setIsOpen={setIsSelectCardModalActive}
      >
        <SelectCard
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
        <div className={styles.proceedButtonContainer}>
          <button
            onClick={retrySubscriptionPaymentHandler}
            className={styles.button}
          >
            Proceed
          </button>
          <button
            onClick={() => setIsSelectCardModalActive(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <WifiAmenityModal
        isOpen={isWifiModalActive}
        setIsOpen={setIsWifiModalActive}
      />
      <div className={styles.mainContainer}>
        {openDoorLoading && <Loading />}
        <div className={styles.bodyContainer}>
          <div className={styles.headingContainer}>
            <h1>Welcome {data?.member?.fullName}</h1>
          </div>
          {moment().isAfter(moment(data?.lease?.endDate)) &&
            !data?.lease?.isActive &&
            data?.lease?.onHold && (
              <div className={styles.alertMessageContainer}>
                <div className={styles.alertMessage}>
                  <div className={styles.alertIcon}>
                    <RiAlertLine />
                  </div>
                  <div className={styles.alertMessageText}>
                    <span className={styles.alertBold}>Alert!</span>
                    <p>Your lease has been expired, kindly contact support</p>
                  </div>
                </div>
              </div>
            )}
          <div className={styles.locationContainerWrapper}>
            <div className={styles.locationLeftSide}>
              <div className={styles.locationContainer}>
                <div className={styles.imageContainer}>
                  <img
                    width={100}
                    height={100}
                    className={styles.image}
                    src="https://images.unsplash.com/photo-1534237710431-e2fc698436d0?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YnVpbGRpbmd8ZW58MHx8MHx8fDA%3D"
                    alt=""
                  />
                </div>
                <div className={styles.locationInfo}>
                  <p className={styles.name}>{data?.building?.name}</p>
                  <p className={styles.address}>
                    {data?.building?.address}, {data?.building?.city},{" "}
                    {data?.building?.state}, {data?.building?.zip}
                  </p>
                </div>
              </div>
              <div className={styles.amenitiesContainer}>
                <div className={styles.headingContainer}>
                  <p>My Amenities</p>
                </div>
                <div className={styles.amenitiesList}>
                  {data?.package?.packageAmenities?.map(
                    (amenity: any, i: number) => {
                      if (amenity?.amenityTypeName === "Wifi") {
                        return (
                          <div
                            className={styles.amenity}
                            key={i}
                            onClick={() => wifiHandler()}
                          >
                            <div className={styles.lockImageContainer}>
                              <img
                                className={styles.lockImage}
                                src={WifiImage}
                                alt="Wifi"
                              />
                            </div>
                            <div className={styles.imageContainer}>
                              <img
                                className={styles.image}
                                width={100}
                                height={100}
                                src={amenity?.image}
                                alt=""
                              />
                            </div>
                            <div className={styles.infoMainContainer}>
                              <div className={styles.infoContainer}>
                                <p className={styles.name}>{amenity?.name}</p>
                                <p className={styles.lastVisited}>
                                  Last Visit{" "}
                                  {amenity?.lastVisited
                                    ? moment(amenity?.lastVisited).format(
                                        "MM/DD/YYYY",
                                      )
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div
                          className={styles.amenity}
                          key={i}
                          onClick={() => openDoorHandler(amenity?.amenityId)}
                        >
                          <div className={styles.lockImageContainer}>
                            <img
                              className={styles.lockImage}
                              src={LockImage}
                              alt="Lock"
                            />
                          </div>
                          <div className={styles.imageContainer}>
                            <img
                              className={styles.image}
                              width={100}
                              height={100}
                              src={amenity?.image}
                              alt=""
                            />
                          </div>
                          <div className={styles.infoMainContainer}>
                            <div className={styles.infoContainer}>
                              <p className={styles.name}>{amenity?.name}</p>
                              <p className={styles.lastVisited}>
                                Last Visit{" "}
                                {amenity?.lastVisited
                                  ? moment(amenity?.lastVisited).format(
                                      "MM/DD/YYYY",
                                    )
                                  : "N/A"}
                              </p>
                            </div>
                            <div className={styles.openDoorContainer}>
                              {openDoorData &&
                              openDoorAmenityId === amenity?.amenityId ? (
                                <FaUnlockAlt className={styles.icon} />
                              ) : (
                                <FaUnlockAlt className={styles.icon} />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
            <div className={styles.summaryContainer}>
              <div className={styles.packageContainer}>
                <div className={styles.info}>
                  <p className={styles.package}>Package</p>
                  <p className={styles.economy}>{data?.package?.packageName}</p>
                  <p className={styles.renew}>
                    Last Renew on{" "}
                    {moment(data?.package?.renewalDate).format("MM/DD/YYYY")}
                  </p>
                </div>
                <div className={styles.buttonContainers}>
                  <Link className={styles.button} to="/upgrade">
                    Upgrade
                  </Link>
                  {data?.member?.registered === false &&
                    data?.member?.subscriptionFailed === true && (
                      <button
                        className={styles.button}
                        onClick={() => setIsSelectCardModalActive(true)}
                      >
                        Retry Payment
                      </button>
                    )}
                </div>
              </div>
              <div className={styles.bookingContainer}>
                <div className={styles.headingContainer}>
                  <p>My Bookings</p>
                  <Link
                    to="/bookings/create"
                    className={styles.buttonContainer}
                  >
                    <button>CREATE BOOKING</button>
                  </Link>
                </div>
                <div className={styles.bookingsList}>
                  {data?.bookings?.map((booking: any, i: number) => {
                    return (
                      <div className={styles.booking} key={i}>
                        <div className={styles.dateContainer}>
                          <CiClock1 size={20} />
                          <div className={styles.date}>
                            <p>
                              {moment(booking?.startTime).format("MM/DD/YYYY")}{" "}
                              <span>
                                {moment(booking?.startTime).format("hh:mm A")} -{" "}
                                {moment(booking?.endTime).format("hh:mm A")}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className={styles.infoContainer}>
                          <p>{booking?.amenityName}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dashboard;
